import React from "react";
import $ from "jquery";
import {
  CurrencyRendererRed,
  NumberRenderer,
  GetESTDateString,
  GetStandardDTButtons,
} from "./../Utilities.js";

class GroupedTbl extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      firm: null,
      acct: null,
      sybl: null,

      group: null,
      agg: null,
      groupChange: null,
      grpData: [],
    };

    this.table = null;
  }

  static getDerivedStateFromProps(props, state) {
    if (props.grpData !== state.grpData) {
      return { ...props, needToUpdate: true };
    } else {
      return { ...props, needToUpdate: false };
    }
  }

  componentDidUpdate(props, state) {
    let self = this;
    //this.table.ajax.url(MWBaseURL()+"daily_grouped_series?"+GetParams(self.state)).load()
    if (this.state.needToUpdate) {
      this.table.clear();
      this.table.rows.add(self.state.grpData);
      if (
        !self.state.group ||
        (self.state.group.length === 4 &&
          self.state.group === GetESTDateString().slice(0, 4)) ||
        (self.state.group.length === 7 &&
          self.state.group === GetESTDateString().slice(0, 7))
      ) {
        let emptyobj = {
          pnl: "N/A",
          gross_pnl: "N/A",
          short_gross: "N/A",
          long_gross: "N/A",
          shares: "N/A",
          locates: "N/A",
          short_shares: "N/A",
          long_shares: "N/A",
          commissions: "N/A",
          short_comm: "N/A",
          stcfees: "N/A",
          short_stc: "N/A",
          tafees: "N/A",
          short_taf: "N/A",
          short_net: "N/A",
          long_net: "N/A",
        };
        if (
          self.state.agg === "YEAR" &&
          !self.state.grpData.some(
            (r) => r.agg === GetESTDateString().slice(0, 4),
          )
        ) {
          this.table.rows.add([
            { ...emptyobj, agg: GetESTDateString().slice(0, 4) },
          ]);
        } else if (
          self.state.agg === "MONTH" &&
          !self.state.grpData.some(
            (r) => r.agg === GetESTDateString().slice(0, 7),
          )
        ) {
          this.table.rows.add([
            { ...emptyobj, agg: GetESTDateString().slice(0, 7) },
          ]);
        } else if (
          self.state.agg === "DAY" &&
          !self.state.grpData.some(
            (r) => r.agg === GetESTDateString().slice(0, 10),
          )
        ) {
          this.table.rows.add([
            { ...emptyobj, agg: GetESTDateString().slice(0, 10) },
          ]);
        }
      }
      this.table.draw();
    }
  }

  componentDidMount() {
    let self = this;
    this.table = $("#groupedTbl").DataTable({
      dom: "Bfrtip",
      scrollX: true,
      scrollY: "50vh",
      scrollCollapse: true,
      fixedColumns: {
        left: 1,
      },
      stateSave: true,
      stateDuration: 0, //infinite
      responsive: true,
      paging: false,
      info: false,
      filter: false,
      buttons: [
        GetStandardDTButtons(
          "Trac P&L Explorer Historical",
          self.state.auth.role.includes("ADMIN"),
        ),
      ],
      /*ajax: {
				url: MWBaseURL()+"daily_grouped_series?"+GetParams(self.state),
				dataSrc: '',
				error: function (xhr, error, code){
					if(xhr.status === 403){
						Handle403(self.state)
					}
				}
			},*/
      columns: [
        {
          title: `Grouping <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-question-circle" viewBox="0 0 16 16">
							<title>Days that don't show a hyperlink are not available in the Explorer.</title>
							<path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
							<path d="M5.255 5.786a.237.237 0 0 0 .241.247h.825c.138 0 .248-.113.266-.25.09-.656.54-1.134 1.342-1.134.686 0 1.314.343 1.314 1.168 0 .635-.374.927-.965 1.371-.673.489-1.206 1.06-1.168 1.987l.003.217a.25.25 0 0 0 .25.246h.811a.25.25 0 0 0 .25-.25v-.105c0-.718.273-.927 1.01-1.486.609-.463 1.244-.977 1.244-2.056 0-1.511-1.276-2.241-2.673-2.241-1.267 0-2.655.59-2.75 2.286zm1.557 5.763c0 .533.425.927 1.01.927.609 0 1.028-.394 1.028-.927 0-.552-.42-.94-1.029-.94-.584 0-1.009.388-1.009.94z"/>
						</svg>`,
          data: "agg",
          render: function (data, type, row, meta) {
            if (row.shares === "N/A") {
              return (
                '<span class="tblfauxlink">' + data + ` (Live Session)</span>`
              );
            } else if (!row.missingExplorerData) {
              return '<span class="tblfauxlink">' + data + "</span>";
            } else {
              return data;
            }
          },
          className: "nocolvis",
        },
        {
          title: "Shares",
          data: "shares",
          render: (data, type, row) =>
            data === "N/A" ? "N/A" : NumberRenderer(data, type),
          className: "text-right",
        },
        {
          title: "Short Shares",
          data: "short_shares",
          render: (data, type, row) =>
            data === "N/A" ? "N/A" : NumberRenderer(data, type),
          className: "text-right",
        },
        {
          title: "Long Shares",
          data: "long_shares",
          render: (data, type, row) =>
            data === "N/A" ? "N/A" : NumberRenderer(data, type),
          className: "text-right",
        },
        {
          title: "Gross P&L",
          data: "gross_pnl",
          render: (data, type, row) =>
            data === "N/A" ? "N/A" : CurrencyRendererRed(data, type),
          className: "text-right",
        },
        {
          title: "Short Gross P&L",
          data: "short_gross",
          render: (data, type, row) =>
            data === "N/A" ? "N/A" : CurrencyRendererRed(data, type),
          className: "text-right",
        },
        {
          title: "Long Gross P&L",
          data: "long_gross",
          render: (data, type, row) =>
            data === "N/A" ? "N/A" : CurrencyRendererRed(data, type),
          className: "text-right",
        },
        {
          title: "Comm",
          data: "commissions",
          render: (data, type, row) =>
            data !== "N/A" ? CurrencyRendererRed(data, type) : "N/A",
          className: "text-right",
        },
        {
          title: "Short Comm",
          data: "short_comm",
          render: (data, type, row) =>
            data !== "N/A" ? CurrencyRendererRed(data, type) : "N/A",
          className: "text-right",
        },
        {
          title: "STC",
          data: "stcfees",
          render: (data, type, row) =>
            data !== "N/A" ? CurrencyRendererRed(data, type) : "N/A",
          className: "text-right",
        },
        {
          title: "Short STC",
          data: "short_stc",
          render: (data, type, row) =>
            data !== "N/A" ? CurrencyRendererRed(data, type) : "N/A",
          className: "text-right",
        },
        {
          title: "TAF / ORF",
          data: "tafees",
          render: (data, type, row) =>
            data !== "N/A" ? CurrencyRendererRed(data, type) : "N/A",
          className: "text-right",
        },
        {
          title: "Short TAF / ORF",
          data: "short_taf",
          render: (data, type, row) =>
            data !== "N/A" ? CurrencyRendererRed(data, type) : "N/A",
          className: "text-right",
        },
        {
          title: "Locates",
          data: "locates",
          render: function (data, type, row) {
            let tracBase = process.env.REACT_APP_RE_AUTH_URL.slice(
              0,
              process.env.REACT_APP_RE_AUTH_URL.lastIndexOf("/") + 1,
            );
            let tracUrl =
              tracBase +
              "locateschargesbysymbol.action?startDate=" +
              row.agg +
              "&endDate=" +
              row.agg;
            let value = CurrencyRendererRed(data, type);
            if (data !== "N/A") {
              if (type !== "sort" && self.state.agg === "DAY") {
                return `<a target="_blank" href="${tracUrl}"/>${value}</a>`;
              }
              return CurrencyRendererRed(data, type);
            }
            return `<a target="_blank" href="${tracUrl}"/>` + data + `</a>`;
          },
          className: "text-right",
        },
        {
          title: "Net P&L",
          data: "pnl",
          render: (data, type, row) =>
            data === "N/A" ? "N/A" : CurrencyRendererRed(data, type),
          className: "text-right",
        },
        {
          title: "Short Net P&L",
          data: "short_net",
          render: (data, type, row) =>
            data === "N/A" ? "N/A" : CurrencyRendererRed(data, type),
          className: "text-right",
        },
        {
          title: "Long Net P&L",
          data: "long_net",
          render: (data, type, row) =>
            data === "N/A" ? "N/A" : CurrencyRendererRed(data, type),
          className: "text-right",
        },
      ],
      columnDefs: [
        {
          targets: [9, 10, 11, 12],
          visible: false,
        },
        {
          targets: "_all",
          type: "numeric",
        },
      ],
      footerCallback: function (row, data, start, end, display) {
        var api = this.api();
        if (data.length) {
          let numFormat = $.fn.dataTable.render.number(",", ".").display;
          let curFormat = $.fn.dataTable.render.number(
            ",",
            ".",
            0,
            "$",
          ).display;
          api.columns().every(function (i) {
            if ([4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16].includes(i)) {
              $(this.footer()).html(
                curFormat(
                  this.data().reduce(
                    (a, b) =>
                      parseFloat(a === "N/A" ? 0 : a) +
                      parseFloat(b === "N/A" ? 0 : b),
                  ),
                ),
              );
            } else if ([1, 2, 3].includes(i)) {
              $(this.footer()).html(
                numFormat(
                  this.data().reduce(
                    (a, b) =>
                      parseFloat(a === "N/A" ? 0 : a) +
                      parseFloat(b === "N/A" ? 0 : b),
                  ),
                ),
              );
            }
            return true;
          });
        }
      },
    });
    $("#groupedTbl").on("click", ".tblfauxlink", function () {
      let row = self.table.row($(this).closest("td")[0]).data();
      self.state.groupChange(null, row.agg);
    });
  }

  render() {
    return (
      <div>
        <table id="groupedTbl" className="display compact mb-1" width="100%">
          <tfoot>
            <tr>
              <th></th>
              <th></th>
              <th></th>
              <th></th>
              <th></th>
              <th></th>
              <th></th>
              <th></th>
              <th></th>
              <th></th>
              <th></th>
              <th></th>
              <th></th>
              <th></th>
              <th></th>
              <th></th>
              <th></th>
            </tr>
          </tfoot>
        </table>
      </div>
    );
  }
}

export default GroupedTbl;
